import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import styles from './../../../style';
import { withRouter } from 'react-router-dom';
import MUIDataTable from 'mui-datatables';

import {
  Card,
  CardContent,
  Grid,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  CircularProgress,
  TextField,
  Tooltip,
  Box,
  Typography,
  Select,
  MenuItem,
  InputAdornment,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper
} from '@material-ui/core';
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles';
import {
  DeleteOutline,
  EditOutlined,
  HistoryOutlined,
  CheckOutlined,
  CloseOutlined
} from '@material-ui/icons';

import { connect } from 'react-redux';
import {
  getPatients,
  editPatient,
  resendActivationEmail
} from 'services/patient/action';
import {
  deleteUser,
  deactivateUser,
  reactivateUser
} from 'services/user/action';
import MessageBox from 'util/messageBox';
import { Skeleton } from '@material-ui/lab';

const View = props => {
  const { classes, className, ehrID, list, ...rest } = props;
  const [data, setData] = useState([]);
  const [succMsg, setSuccMsg] = useState(false);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);
  const [poploading, setPopLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [editErrors, setEditErrors] = useState({});
  const [handledeletepopup, setHandleDeletePopup] = useState({
    showDeletePopup: false,
    deleteUserId: ''
  });
  const [handledeactivatepopup, setHandleDeactivatePopup] = useState({
    showDeactivatePopup: false,
    deactivateUserId: ''
  });

  useEffect(() => {
    props.getPatients(ehrID, 0, '', rowsPerPage);
  }, []);

  useEffect(() => {
    if (props.list !== undefined) {
      const datatopush = list.result.map(item => {
        const rawMobile = item.mobilenumber || '';
        const countryCode = detectCountryCode(rawMobile.toString());
        const localNumber = stripCountryCode(rawMobile.toString());

        return {
          patient: item,
          mobilenumber: localNumber,
          countryCode: countryCode,
          name: (item.lastName || '') + ', ' + (item.firstName || ''),
          patientId: item.patientId,
          id: item.id,
          username: item.userName,
          email: item.emailAddress,
          status: item.enabled ? 'Active' : 'Inactive',
          enabled: item.enabled,
          showEdit: false,
          loading: false,
          _originalEmail: item.emailAddress,
          _originalMobile: localNumber,
          _originalCountryCode: countryCode
        };
      });
      setData(datatopush);
      setLoading(false);
    }
  }, [props.list]);

  // ── Delete ──────────────────────────────────────────────
  const handleDelete = userID =>
    setHandleDeletePopup({ showDeletePopup: true, deleteUserId: userID });

  const handleCancelDelete = () =>
    setHandleDeletePopup({ showDeletePopup: false });

  const handleDeleteUser = deleteUserId => {
    if (deleteUserId > 0) {
      props.deleteUser(ehrID, deleteUserId);
      setHandleDeletePopup({ showDeletePopup: false });
    }
  };

  // ── Pagination / Search ─────────────────────────────────
  const handleChangePage = async page => {
    setLoading(true);
    setPage(page);
    await props.getPatients(ehrID, page, '', rowsPerPage);
    window.scrollTo(0, 0);
  };

  const handleChangeRowsPerPage = event => {
    setLoading(true);
    setRowsPerPage(event);
    props.getPatients(ehrID, page, '', event);
    window.scrollTo(0, 0);
  };

  const handleSearch = async (search, isClear) => {
    setSearch(search);
    if ((search && search !== '') || isClear) {
      await props.getPatients(ehrID, 0, search, rowsPerPage);
    }
  };

  // ── Inline Edit ─────────────────────────────────────────
  const handleEditChange = id => {
    setData(prev =>
      prev.map(item =>
        item.id === id ? { ...item, showEdit: true } : item
      )
    );
  };

  const handleFieldChange = (field, value, id) => {
    setData(prev =>
      prev.map(item =>
        item.id === id ? { ...item, [field]: value } : item
      )
    );
  };

  const COUNTRY_CODES = [
    { code: '+91', prefix: '91', digits: 10, flag: '🇮🇳' },
    { code: '+1', prefix: '1', digits: 10, flag: '🇺🇸' },
  ];

  // Detect country code from raw number like "918089526799"
  const detectCountryCode = raw => {
    if (!raw || raw === '-') return '+1';
    const cleaned = raw.replace(/\D/g, ''); // strip non-digits

    for (const country of COUNTRY_CODES) {
      if (cleaned.startsWith(country.prefix)) {
        const remaining = cleaned.slice(country.prefix.length);
        if (remaining.length === country.digits) {
          return country.code;
        }
      }
    }
    return '+1'; // default
  };

  // Strip the country prefix and return just the local number
  const stripCountryCode = raw => {
    if (!raw || raw === '-') return '-';
    const cleaned = raw.replace(/\D/g, '');

    for (const country of COUNTRY_CODES) {
      if (cleaned.startsWith(country.prefix)) {
        const remaining = cleaned.slice(country.prefix.length);
        if (remaining.length === country.digits) {
          return remaining; // e.g. "8089526799"
        }
      }
    }
    return cleaned; // fallback — return as-is
  };


  const handleUpdatePatient = patient => {
    // ── Validate ──────────────────────────────────────────
    const errors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!patient.email || patient.email.trim() === '') {
      errors[`email_${patient.id}`] = 'Email is required';
    } else if (!emailRegex.test(patient.email.trim())) {
      errors[`email_${patient.id}`] = 'Enter a valid email address';
    }

    if (!patient.mobilenumber || patient.mobilenumber === '-' || patient.mobilenumber.trim() === '') {
      errors[`mobile_${patient.id}`] = 'Mobile number is required';
    } else if (patient.mobilenumber.replace(/\D/g, '').length !== 10) {
      errors[`mobile_${patient.id}`] = 'Enter a valid 10-digit number';
    }

    if (Object.keys(errors).length > 0) {
      setEditErrors(errors);
      return; // stop here — don't call API
    }

    // ── Clear errors and proceed ──────────────────────────
    setEditErrors({});

    const fullMobile = patient.mobilenumber && patient.mobilenumber !== '-'
      ? `${patient.countryCode?.replace('-CA', '')}${patient.mobilenumber}`
      : null;

    const user = {
      emailaddress: patient.email,
      ehrid: patient.ehrId,
      firstname: patient.firstName,
      lastname: patient.lastName,
      enable: patient.enabled,
      role: patient.role,
      username: patient.userName,
      mobilenumber: fullMobile,   // ← sends e.g. "+911234567890"
      id: patient.id
    };

    props.editPatient(ehrID, patient.id, user).then(res => {
      if (res) {
        setData(prev =>
          prev.map(item =>
            item.id === patient.id
              ? {
                ...item,
                showEdit: false,
                _originalEmail: patient.email,
                _originalMobile: patient.mobilenumber,
                _originalCountryCode: patient.countryCode
              }
              : item
          )
        );
        props.getPatients(ehrID, page, '', rowsPerPage);
      }
    });
  };

  const handleCancelEdit = id => {
    setEditErrors(prev => {
      const updated = { ...prev };
      delete updated[`email_${id}`];
      delete updated[`mobile_${id}`];
      return updated;
    });

    setData(prev =>
      prev.map(item =>
        item.id === id
          ? {
            ...item,
            showEdit: false,
            email: item._originalEmail,
            mobilenumber: item._originalMobile,
            countryCode: item._originalCountryCode  // ← revert code
          }
          : item
      )
    );
  };

  // ── Resend Activation ───────────────────────────────────
  const handleResendActivation = resendActivationUserId => {
    const index = data.findIndex(c => c.id === resendActivationUserId);
    if (index !== -1) {
      setData(prev =>
        prev.map((item, i) => (i === index ? { ...item, loading: true } : item))
      );
    }
    if (resendActivationUserId > 0) {
      props
        .resendActivationEmail(ehrID, resendActivationUserId)
        .then(res => { if (res) setSuccMsg(true); })
        .catch(err => console.error('Resend activation failed:', err))
        .finally(() => {
          if (index !== -1) {
            setData(prev =>
              prev.map((item, i) =>
                i === index ? { ...item, loading: false } : item
              )
            );
          }
        });
    }
  };

  // ── Deactivate / Reactivate ─────────────────────────────
  const handleDeactivate = userID =>
    setHandleDeactivatePopup({ showDeactivatePopup: true, deactivateUserId: userID });

  const handleCancelDeactivate = () =>
    setHandleDeactivatePopup({ showDeactivatePopup: false });

  const handleDeactivateUser = async deactivateUserId => {
    if (deactivateUserId > 0) {
      setPopLoading(true);
      const res = await props.deactivateUser(ehrID, deactivateUserId);
      if (res) {
        setData(prev =>
          prev.map(item =>
            item.id === deactivateUserId ? { ...item, enabled: false } : item
          )
        );
      }
    }
    setPopLoading(false);
    setHandleDeactivatePopup({ showDeactivatePopup: false });
  };

  const handleReactivateUser = async reactivateUserId => {
    if (reactivateUserId > 0) {
      setPopLoading(true);
      const res = await props.reactivateUser(ehrID, reactivateUserId);
      if (res) {
        setData(prev =>
          prev.map(item =>
            item.id === reactivateUserId ? { ...item, enabled: true } : item
          )
        );
      }
      setPopLoading(false);
    }
  };

  const handleCloseAll = () => setSuccMsg(false);

  const formatLocalNumber = (number, countryCode) => {
    if (!number || number === '-') return '-';
    const digits = number.replace(/\D/g, '');

    if (countryCode === '+1') {
      // US/CA format: (XXX) XXX-XXXX
      return digits.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
    }
    if (countryCode === '+91') {
      // India format: XXXXX-XXXXX
      return digits.replace(/(\d{5})(\d{5})/, '$1-$2');
    }
    return digits;
  };

  // ── Theme ───────────────────────────────────────────────
  const theme = createTheme({
    overrides: {
      MUIDataTable: { responsiveScroll: { maxHeight: 'none !important' } },
      MuiTableCell: { root: { padding: '5px 10px', fontSize: 12 } },
      MuiToolbar: { root: { minHeight: '48px!important' } },
      MUIDataTableHeadRow: { root: { backgroundColor: '#EFF5FC!important' } },
      MUIDataTableHeadCell: {
        toolButton: { fontSize: 12 },
        fixedHeader: {
          backgroundColor: 'transparent!important',
          height: 45,
          borderTop: '1px solid #D4E5F9',
          borderBottom: '1px solid #D4E5F9'
        }
      },
      MUIDataTableSelectCell: {
        headerCell: {
          backgroundColor: 'transparent!important',
          height: 45,
          borderTop: '1px solid #D4E5F9',
          borderBottom: '1px solid #D4E5F9'
        }
      },
      MUIDataTableToolbar: {
        icon: { transform: 'scale(.8)' },
        titleText: {
          fontSize: '16px!important',
          fontWeight: '600!important',
          fontFamily: 'Lato!important'
        }
      },
      MUIDataTableToolbarSelect: {
        root: {
          paddingTop: 0,
          paddingBottom: 0,
          backgroundColor: 'rgba(255,0,0,.2)',
          boxShadow: 'none',
          borderRadius: '0px!important'
        }
      },
      MuiTableRow: { root: { '&$hover:hover': { backgroundColor: '#EFF5FC' } } },
      MuiTablePagination: { caption: { fontSize: 12 } }
    }
  });

  // ── Columns ─────────────────────────────────────────────
  const columns = [
    {
      name: 'name',
      label: 'Patients'
    },
    {
      name: 'email',
      label: 'Email',
      options: {
        sort: false,
        customBodyRender: (value, tableMeta) => {
          const record = data.find(c => c.id === tableMeta.rowData[tableMeta.rowData.length - 1]);
          const showEdit = record?.showEdit;

          return showEdit ? (
            <TextField
              name="email"
              required
              variant="outlined"
              size="small"
              defaultValue={value}
              onChange={event => {
                handleFieldChange('email', event.target.value, record.id);
                // clear error on type
                if (editErrors[`email_${record.id}`]) {
                  setEditErrors(prev => ({ ...prev, [`email_${record.id}`]: null }));
                }
              }}
              error={!!editErrors[`email_${record.id}`]} 
              inputProps={{ style: { padding: '6px 10px' } }}
              style={{ minWidth: 190 }}
            />
          ) : (
            <Typography variant="body2">{value}</Typography>
          );
        }
      }
    },
    {
      name: 'mobilenumber',
      label: 'Mobile',
      options: {
        sort: false,
        customBodyRender: (value, tableMeta) => {
          const record = data.find(c => c.id === tableMeta.rowData[tableMeta.rowData.length - 1]);
          const showEdit = record?.showEdit;

          return showEdit ? (
            <Box display="flex" alignItems="center" style={{ gap: 4 }}>
              <Select
                variant="outlined"
                value={record.countryCode || '+1'}
                onChange={event =>
                  handleFieldChange('countryCode', event.target.value, record.id)
                }
                style={{ height: 32, fontSize: 12 }}
                inputProps={{ style: { padding: '6px 8px' } }}
              >
                <MenuItem value="+1">
                  <Box display="flex" alignItems="center" style={{ gap: 6 }}>
                    <span>+1</span>
                  </Box>
                </MenuItem>
                <MenuItem value="+91">
                  <Box display="flex" alignItems="center" style={{ gap: 6 }}>
                    <span>+91</span>
                  </Box>
                </MenuItem>
              </Select>

              <TextField
                name="mobilenumber"
                variant="outlined"
                size="small"
                defaultValue={record._originalMobile === '-' ? '' : record._originalMobile}
                onChange={event => {
                  handleFieldChange('mobilenumber', event.target.value, record.id);
                  // clear error on type
                  if (editErrors[`mobile_${record.id}`]) {
                    setEditErrors(prev => ({ ...prev, [`mobile_${record.id}`]: null }));
                  }
                }}
                error={!!editErrors[`mobile_${record.id}`]} 
                inputProps={{
                  style: { padding: '6px 10px' },
                  maxLength: 10
                }}
                style={{ minWidth: 130 }}
              />
            </Box>
          ) : (
            <Typography variant="body2">
              {record?.mobilenumber && record.mobilenumber !== '-'
                ? `${record.countryCode} ${formatLocalNumber(record.mobilenumber.toString(), record.countryCode.toString())}`
                : '-'}
            </Typography>
          );
        }
      }
    },
    {
      name: 'id',
      label: 'Status',
      options: {
        sort: false,
        customBodyRender: (value) => {
          const enabled = data.find(c => c.id === value)?.enabled;
          return enabled ? (
            <Button
              title="Click to deactivate user."
              color="primary"
              onClick={() => handleDeactivate(value)}
              size="small"
              style={{ textTransform: 'capitalize', padding: '2px' }}>
              Active
            </Button>
          ) : (
            <Button
              title="Click to reactivate user."
              onClick={() => handleReactivateUser(value)}
              size="small"
              style={{ textTransform: 'capitalize', padding: '2px' }}>
              Inactive
            </Button>
          );
        }
      }
    },
    {
      name: 'id',
      label: 'Actions',
      options: {
        sort: false,
        setCellProps: () => ({
          style: {
            textAlign: 'center',
            whiteSpace: 'nowrap',
            width: '120px',        // ← fixed width
            minWidth: '120px',     // ← prevents collapse
            maxWidth: '120px',     // ← prevents expansion
            padding: '4px 8px'
          }
        }),
        setCellHeaderProps: () => ({
          style: {
            textAlign: 'center',
            width: '120px',
            minWidth: '120px',
            maxWidth: '120px',
          }
        }),
        customBodyRender: (value, tableMeta) => {
          // value IS the id here since the column name is 'id' — still safe
          const record = data.find(c => c.id === value);
          const showEdit = record?.showEdit;
          const enabled = record?.enabled;
          const rowLoading = record?.loading;

          if (showEdit) {
            return (
              <Box display="flex" alignItems="center" justifyContent="center">
                <span style={{ display: 'inline-block', width: 28, height: 28 }} />
                <Tooltip title="Save">
                  <IconButton
                    size="small"
                    style={{ color: '#4CAF50' }}
                    onClick={() => handleUpdatePatient(record)}>
                    <CheckOutlined fontSize="small" />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Cancel">
                  <IconButton
                    size="small"
                    style={{ color: '#F44336' }}
                    onClick={() => handleCancelEdit(value)}>
                    <CloseOutlined fontSize="small" />
                  </IconButton>
                </Tooltip>
              </Box>
            );
          }

          return (
            <Box display="flex" alignItems="center" justifyContent="center">
              {!enabled ? (
                <Tooltip title="Resend Activation">
                  <IconButton size="small" onClick={() => handleResendActivation(value)}>
                    {rowLoading
                      ? <CircularProgress size={18} />
                      : <HistoryOutlined fontSize="small" />}
                  </IconButton>
                </Tooltip>
              ) : (
                <span style={{ display: 'inline-block', width: 28, height: 28 }} />
              )}
              <Tooltip title="Edit">
                <IconButton size="small" onClick={() => handleEditChange(value)}>
                  <EditOutlined fontSize="small" />
                </IconButton>
              </Tooltip>
              <Tooltip title="Delete">
                <IconButton size="small" onClick={() => handleDelete(value)}>
                  <DeleteOutline fontSize="small" style={{ color: '#ED2024' }} />
                </IconButton>
              </Tooltip>
            </Box>
          );
        }
      }
    }
  ];

  const options = {
    filter: false,
    responsive: 'scroll',
    elevation: 0,
    rowsPerPage,
    rowsPerPageOptions: [10, 20, 50, 100],
    download: false,
    print: false,
    search: true,
    viewColumns: false,
    pagination: props.list && props.list.totalElements > 20,
    serverSide: true,
    count: props.list && props.list.totalElements,
    page,
    filterType: 'select',
    selectableRows: false,
    searchPlaceholder: 'Search for patients',
    onTableChange: (action, tableState) => {
      switch (action) {
        case 'changePage': handleChangePage(tableState.page); return;
        case 'changeRowsPerPage': handleChangeRowsPerPage(tableState.rowsPerPage); return;
        case 'search': handleSearch(tableState.searchText); return;
        default: return;
      }
    },
    searchText: search,
    onSearchClose: () => handleSearch('', true)
  };

  const LoadingTableBody = ({ loading, ...props }) => {
    const { options, columns, ...others } = props;

    if (loading) {
      // Only replace the rows, keep header/toolbar from MUIDataTable
      return <TableRowsLoader rowsNum={20} colsNum={5} />;
    }

    // Fallback to original internal body
    const DefaultBody = require('mui-datatables').TableBody; // v3/v4 internal export

    return <DefaultBody options={options} columns={columns} {...others} />;
  };

  const BodyComponent = React.useMemo(
    () => (props) => <LoadingTableBody loading={loading} {...props} />,
    [loading]
  );

  const TableRowsLoader = ({ rowsNum = 10, colsNum = 5 }) => (
    <TableBody>
      {[...Array(rowsNum)].map((_, rowIdx) => (
        <TableRow key={rowIdx}>
          {[...Array(colsNum)].map((_, colIdx) => (
            <TableCell key={colIdx}>
              <Skeleton animation="wave" variant="text" />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </TableBody>
  );

  return (
    <Card {...rest} className={clsx(classes.cardRoot, className)}>
      <CardContent style={{ margin: -16 }}>
        <Grid container spacing={0}>
          <Grid item xs={12}>
            <MuiThemeProvider theme={theme}>
              <MUIDataTable
                title={'View/Manage Patients'}
                data={data}
                columns={columns}
                options={options}
                components={{
                  TableBody: BodyComponent,
                }}
              />
            </MuiThemeProvider>

          </Grid>
        </Grid>
      </CardContent>

      {/* Delete Dialog */}
      <Dialog
        disableBackdropClick
        disableEscapeKeyDown
        maxWidth="xs"
        aria-labelledby="confirmation-dialog-title"
        open={handledeletepopup.showDeletePopup}>
        <DialogTitle id="confirmation-dialog-title">Account Settings</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this user account?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleDeleteUser(handledeletepopup.deleteUserId)} color="primary">
            Yes
          </Button>
          <Button onClick={handleCancelDelete} color="primary">No</Button>
        </DialogActions>
      </Dialog>

      {/* Deactivate Dialog */}
      <Dialog
        disableBackdropClick
        disableEscapeKeyDown
        maxWidth="xs"
        aria-labelledby="confirmation-dialog-title"
        open={handledeactivatepopup.showDeactivatePopup}>
        <DialogTitle id="confirmation-dialog-title">Account Settings</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to de-activate the user account?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => handleDeactivateUser(handledeactivatepopup.deactivateUserId)}
            color="primary">
            Yes
          </Button>
          {poploading
            ? <CircularProgress className={classes.progress} size={20} />
            : <Button onClick={handleCancelDeactivate} color="primary">No</Button>}
        </DialogActions>
      </Dialog>

      <MessageBox
        open={succMsg}
        variant="success"
        onClose={handleCloseAll}
        message="Account activation mail sent successfully"
      />
    </Card>
  );
};

View.propTypes = { className: PropTypes.string };

const mapDispatchToProps = {
  getPatients, deleteUser, editPatient,
  resendActivationEmail, deactivateUser, reactivateUser
};
const mapStateToProps = state => ({
  ehrID: state.profile && state.profile.ehrID,
  list: state.patient && state.patient.list
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(View))
);